import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * A set of files deployed from the repository to S3 and read directly.
 *
 * Distinct from a {@link KnowledgeBase}, which is a store plus vector
 * ingestion. Declare a store when files only need to be readable, and a
 * knowledge base when their contents also need to be searchable: a store costs
 * no index, no embeddings, and no ingestion.
 *
 * Values must match the `id` passed to `Store.define()` in
 * `@attain-apps-be/agent-stores`.
 */
export enum Store {
  PptGeneratorAssets = 'ppt-generator-assets',
  ProposalGeneratorAssets = 'proposal-generator-assets',
}

const STORES: ReadonlySet<Store> = new Set(Object.values(Store) as Store[])

export namespace Store {
  /** All stores defined by the application. */
  export const ALL: readonly Store[] = Array.from(STORES)

  /** Checks whether a value identifies a defined store. */
  export const isStore = TypeChecker.Factory.oneOf(STORES)

  /** Asserts that a value identifies a defined store. */
  export const assertIsStore: TypeAsserter<Store> =
    TypeAsserter.Factory.from(isStore)
}
